import { Navigate } from 'react-router-dom';
import { usePermission } from '../hooks/usePermission';

const PermissionRoute = ({ resource, children }) => {
  const { can } = usePermission();
  if (!can('view', resource)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default PermissionRoute;
